export function setCaretAtOffset(el: HTMLElement, offset: number) {
    const selection = window.getSelection();
    if (!selection) return;

    const range = document.createRange();

    const textNode = el.firstChild;
    if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        range.setStart(textNode, Math.min(Math.max(offset, 0), textNode.textContent?.length || 0));
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

export function getCaretOffset(element: HTMLElement): number {
    const sel = window.getSelection();
    let caretOffset = 0;

    if (sel && sel.rangeCount > 0) {
        const range = sel.getRangeAt(0);
        const preCaretRange = range.cloneRange();

        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.endContainer, range.endOffset);

        caretOffset = preCaretRange.toString().length;
    }

    return caretOffset;
}
